import { render } from "./DuplicateFilesModalComponent.vue?vue&type=template&id=9bc6e850&ts=true"
import script from "./DuplicateFilesModalComponent.vue?vue&type=script&lang=ts"
export * from "./DuplicateFilesModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__